import React, {useMemo} from 'react'
import {
    Box,
    Button,
    Link as ChakraLink,

    /* Hooks */
    useMultiStyleConfig
} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

/* Utils */
import {renderComponentsSwitch} from '../../utils/contentRenderer'
import {generateStyles} from '../../utils/utils'

/* Contexts */
import { useGetLinkData } from '../../../../contexts/category-url-context'

const CategoryLinkBlock = ({
    __typename,
    CtaPlacement,
    TextColor,
    CategoryCarouselSize,
    CategoryCarouselBlockCTATextStyle,
    Underline,

    // Own props
    CategoryId,
    CategoryName,
    AltText,
    ResponsiveBackgroundMedia,
    resolvedUrl, // SSR-injected URL

    // Image optimization props (passed from carousel)
    widths = null,
    sizes = null,
    preset = 'TILE',
    cdnOptions = null,
    ...props
}) => {
    const styles = useMultiStyleConfig('CategoryLinkBlock', {
        ...props,
        ResponsiveBackgroundMedia: ResponsiveBackgroundMedia,
        CategoryCarouselSize: CategoryCarouselSize,
        Underline: Underline
    })

    const getLinkData = useGetLinkData()

    const linkData = useMemo(() => {
        return getLinkData({__typename, CategoryId, resolvedUrl})
    }, [__typename, CategoryId, resolvedUrl])

    const hasLink = !!linkData?.generatedURL

    const linkProps = hasLink
        ? {
            as: linkData?.isExternalUrl ? ChakraLink : Link,
            ...(linkData?.isExternalUrl ? {href: linkData.generatedURL} : {to: linkData.generatedURL}),
            ...(!linkData.stayOnSamePage && {target: linkData?.target, rel: linkData?.rel})
        }
        : {}

    return (
        <Box {...styles.carouselItem} data-block-type="CategoryLinkBlock">
            <Box>
                <Button variant="unstyled" {...linkProps}>
                    <Box {...styles.carouselImageWrapper}>
                        {ResponsiveBackgroundMedia &&
                            renderComponentsSwitch(ResponsiveBackgroundMedia?.Expanded, {
                                AltText: AltText,
                                widths,
                                sizes,
                                preset,
                                cdnOptions,
                                // Override inline height:auto to allow aspect ratio container to control dimensions
                                customMediaStyling: {height: '100%', objectFit: 'cover'}
                            })}
                    </Box>
                </Button>
                <Button
                    variant="link"
                    {...generateStyles(CategoryCarouselBlockCTATextStyle, {...styles.link})}
                    {...linkProps}
                >
                    {CategoryName}
                </Button>
            </Box>
        </Box>
    )
}

CategoryLinkBlock.propTypes = {
    __typename: PropTypes.string,
    CtaPlacement: PropTypes.string,
    TextColor: PropTypes.string,
    CategoryCarouselSize: PropTypes.string,
    CategoryCarouselBlockCTATextStyle: PropTypes.object,
    Underline: PropTypes.bool,
    CategoryId: PropTypes.number,
    CategoryName: PropTypes.string,
    AltText: PropTypes.string,
    ResponsiveBackgroundMedia: PropTypes.object,
    widths: PropTypes.arrayOf(PropTypes.number),
    sizes: PropTypes.string,
    preset: PropTypes.string,
    cdnOptions: PropTypes.object
}

export default CategoryLinkBlock
